/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreprocessOrdersToShipDto } from '../../models/preprocess-orders-to-ship-dto';
import { PreprocessOrdersToShipResponseDto } from '../../models/preprocess-orders-to-ship-response-dto';

export interface MgmtOrdersToShipControllerPreprocess$Params {
      body: PreprocessOrdersToShipDto
}

export function mgmtOrdersToShipControllerPreprocess(http: HttpClient, rootUrl: string, params: MgmtOrdersToShipControllerPreprocess$Params, context?: HttpContext): Observable<StrictHttpResponse<PreprocessOrdersToShipResponseDto>> {
  const rb = new RequestBuilder(rootUrl, mgmtOrdersToShipControllerPreprocess.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PreprocessOrdersToShipResponseDto>;
    })
  );
}

mgmtOrdersToShipControllerPreprocess.PATH = '/api/mgmt-orders/to-ship/preprocess';
